import { createSlice } from "@reduxjs/toolkit";
import { A4_WIDTH_72DPI } from "components/DocumentViewer/constants";

export const INITIAL_STATE = {
  baseWidth: A4_WIDTH_72DPI,
  currentPage: 1,
  documentParagraphs: [],
  isPanelOpen: false,
  pageIntros: [],
  paragraphRows: {},
  totalPages: 1,
  zoom: 1,
};

export const documentViewerSlice = createSlice({
  name: "general",
  initialState: INITIAL_STATE,
  reducers: {
    resetDocumentState(state) {
      const prevIsPanelOpen = state?.isPanelOpen ?? INITIAL_STATE.isPanelOpen;
      return { ...INITIAL_STATE, isPanelOpen: prevIsPanelOpen };
    },
    setCurrentPage(state, { payload = 1 }) {
      state.currentPage = payload;
    },
    setIsPanelOpen(state, { payload }) {
      state.isPanelOpen = Boolean(payload);
    },
    setDocumentMetadata(state, { payload }) {
      state.baseWidth = payload.baseWidth || A4_WIDTH_72DPI;
      state.totalPages = payload?.totalPages || 1;
      state.pageIntros = payload?.pageIntros || [];
      state.paragraphRows = payload?.paragraphRows || {};
      state.documentParagraphs = payload?.documentParagraphs || [];
    },
    setPageIntros(state, { payload }) {
      state.pageIntros = payload || [];
    },
    setTotalPages(state, { payload }) {
      state.totalPages = payload || 1;
    },
    setZoom(state, { payload }) {
      state.zoom = payload || 1;
    },
  },
});

export const {
  resetDocumentState,
  setCurrentPage,
  setIsPanelOpen,
  setDocumentMetadata,
  setPageIntros,
  setTotalPages,
  setZoom,
} = documentViewerSlice.actions;

export default documentViewerSlice.reducer;
